import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import styled from 'styled-components';
import { get } from 'lodash';
import RoutesUtils from 'utils/RoutesUtils.class';
import * as storageUtils from 'utils/storageUtils';

import Loading from 'components/Loading/Loading';
import SideMenu from './sideMenu/SideMenu';
import routes from './routes';

import ConsoleTitle from './components/ConsoleTitle/ConsoleTitle';
import AppSnackbar from './components/AppSnackbar/AppSnackbar';

const StyledApp = styled.div`
  display: flex;
  flex-direction: row;

  height: 100%;
  width: 100%;
`;

const Viewport = styled.div`
  height: 100%;
  width: 100%;

  overflow-y: scroll;
`;

const renderRoutes = match => {
  return (
    routes.map((route, key) => (
      <Route
        key={key}
        path={`${match.url}${route.path}`}
        exact={route.exact}
        render={props => (
          <div>
            {route.showTitle && <ConsoleTitle> {route.title} </ConsoleTitle>}
            {RoutesUtils.renderRoute(route, props)}
          </div>
        )}
      />
    ))
  );
};

const checkConnectionStatus = (account) => {
  const userId = get(account, 'id');
  const allIds = storageUtils.getArray(storageUtils.CONNECTION_STATUS);
  return !!allIds.includes(userId);
};

const Layout = ({
  account,
  fetchSuccess,
  fetchPending,
  match,
}) => {
  if (fetchPending) return <Loading loadingLabel="Authorization..." />;
  const isConnected = checkConnectionStatus(account);

  if (!account) return null;

  return (
    <StyledApp>
      <SideMenu routes={routes} />

      <Viewport>
        <Switch>
          {fetchSuccess && renderRoutes(match)}
          {isConnected && <Redirect from="/console" to="/console/users" exact />}
          {!isConnected && <Redirect from="/console" to="/console/sources" exact />}
        </Switch>
      </Viewport>

      <AppSnackbar />
    </StyledApp>
  );
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Layout.jsx